module.exports = __webpack_public_path__ + "img/intmax.c89615e6.png";